import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationRephraseShortFormAssetsArgs } from 'src/types/backend';

type Variables = Omit<BackendMutationRephraseShortFormAssetsArgs, 'async'>;

type FeedJob = Pick<BackendJob, 'id' | 'status'>;

interface Options {
  abortSignal?: AbortSignal;
}

const MUTATION = gql`
  mutation RephraseShortFormAssets(
    $projectId: ID!
    $originalVariationId: ID
    $assetType: String
    $generationTool: GenerationToolEnum!
    $brief: BriefInput
    $scoringMethod: ScoringMethodInput
    $productName: String
    $text: String!
    $recomposeMode: String
    $keywords: String
    $language: String!
    $languageTargetFormality: LanguageTargetFormalityEnum
    $numberOfVariations: Int!
    $debugAcPrompt: String
    $sourceType: String
    $onlyImproveScore: Boolean
    $customerPersonaId: ID
    $annotations: [SuggestionAnnotationInput!]
    $manualInstructions: String
    $tovInput: TovInput
    $forceZeroScore: Boolean
    $rephraseContext: JSON
    $structureInstructionsData: JSON
    $imageResourceId: ID
    $imageStyleId: ID
    $imageOverlayProperties: ImageOverlayTextInput
  ) {
    rephraseShortFormAssets(
      projectId: $projectId
      originalVariationId: $originalVariationId
      assetType: $assetType
      generationTool: $generationTool
      brief: $brief
      scoringMethod: $scoringMethod
      productName: $productName
      text: $text
      recomposeMode: $recomposeMode
      keywords: $keywords
      language: $language
      languageTargetFormality: $languageTargetFormality
      numberOfVariations: $numberOfVariations
      debugAcPrompt: $debugAcPrompt
      sourceType: $sourceType
      onlyImproveScore: $onlyImproveScore
      customerPersonaId: $customerPersonaId
      annotations: $annotations
      manualInstructions: $manualInstructions
      tovInput: $tovInput
      forceZeroScore: $forceZeroScore
      rephraseContext: $rephraseContext
      structureInstructionsData: $structureInstructionsData
      imageResourceId: $imageResourceId
      imageStyleId: $imageStyleId
      imageOverlayProperties: $imageOverlayProperties
    ) {
      id
      status
    }
  }
`;

export const rephraseShortFormAssets = async (
  { structureInstructionsData, ...rest }: Variables,
  options: Options | null = null
): Promise<FeedJob | null> => {
  const variables = {
    ...rest,
    structureInstructionsData: stringifyIfPresent(structureInstructionsData),
  };

  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });

  return getSingleProp<FeedJob>(response.data) ?? null;
};
